import useAnimalFilter from './animal/useAnimalFilter';
import useMemberFilter from './member/useMemberFilter';
import { useEffect, useState } from 'react';
import useGridStore from '@/studbook/store/useGridStore';
import useSearchStore from '@/studbook/store/useSearchStore';

export default function useSearch(
  orgId: string,
  paginationModel: { page: number; pageSize: number },
) {
  const { gridSortModel, setGridSortModel } = useGridStore();
  const { searchType, openResult, canSearch, setSearchChange } =
    useSearchStore();
  const animalQuery = useAnimalFilter(
    orgId,
    paginationModel,
    searchType === 'animal',
  );
  const memberQuery = useMemberFilter(
    orgId,
    paginationModel,
    searchType === 'member',
  );
  const resetSearchOperations = (
    animalQuery: ReturnType<typeof useAnimalFilter>,
    memberQuery: ReturnType<typeof useMemberFilter>,
  ) =>
    searchType === 'animal'
      ? {
          gridSortModel,
          setGridSortModel,
          data: animalQuery.data?.animals,
          entities: animalQuery.entities,
          previousData: animalQuery.previousData?.animals,
          done: animalQuery.done,
          loading: animalQuery.loading,
          dataGrid: animalQuery.dataGrid,
          defaultColumnFieldOrder: animalQuery.defaultColumnFieldOrder,
          startSearch: animalQuery.startSearch,
          resetColumnOrder: animalQuery.resetColumnOrder,
        }
      : {
          gridSortModel,
          setGridSortModel,
          data: memberQuery.data?.members,
          previousData: memberQuery.previousData?.members,
          done: memberQuery.done,
          loading: memberQuery.loading,
          dataGrid: memberQuery.dataGrid,
          startSearch: memberQuery.startSearch,
        };
  const [searchOperations, setSearchOperations] = useState(
    resetSearchOperations(animalQuery, memberQuery),
  );

  useEffect(() => {
    if (!canSearch) return;

    setSearchOperations(resetSearchOperations(animalQuery, memberQuery));
    setSearchChange(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    animalQuery.data?.animals,
    memberQuery.data?.members,
    memberQuery.dataGrid.columns,
    canSearch,
    searchType,
  ]);

  useEffect(() => {
    if (
      !orgId ||
      !searchOperations.dataGrid.columns ||
      searchOperations.dataGrid.columns.length === 0
    )
      return;
    if (
      openResult &&
      !searchOperations.loading &&
      (!searchOperations.dataGrid.rows ||
        searchOperations.dataGrid.rows.length === 0)
    ) {
      searchOperations.startSearch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchOperations.dataGrid.columns]);

  return searchOperations;
}
